package it.neckar.lizergy.model.configuration.energy.power

import it.neckar.lizergy.model.energy.economics.IncreasingPricePerKWh
import it.neckar.lizergy.model.energy.economics.PricePerKWh
import it.neckar.lizergy.model.financial.currency.cents100
import it.neckar.open.kotlin.lang.percent
import it.neckar.open.unit.other.pct
import it.neckar.open.unit.time.pa
import kotlinx.serialization.Serializable

/**
 * A scenario for prices
 */
@Serializable
data class PricesTrendScenario(
  /**
   * The guaranteed feed in price
   */
  val guaranteedFeedInPrice: PricePerKWh? = null,

  /**
   * The consumption price
   */
  val consumptionPrice: PricePerKWh,

  /**
   * The yearly price increase for the consumption price
   */
  val consumptionPriceIncreasePercentage: @pct @pa Double,
) {

  /**
   * Returns the consumption price as increasing price
   */
  fun consumptionPriceAsIncreasing(): IncreasingPricePerKWh {
    return IncreasingPricePerKWh(consumptionPrice, consumptionPriceIncreasePercentage)
  }

  companion object {
    fun typical(): PricesTrendScenario {
      return PricesTrendScenario(
        guaranteedFeedInPrice = null,
        consumptionPrice = PricePerKWh(39.cents100),
        consumptionPriceIncreasePercentage = 4.percent
      )
    }

    fun demoQuote(): PricesTrendScenario {
      return PricesTrendScenario(
        guaranteedFeedInPrice = null,
        consumptionPrice = PricePerKWh(51.cents100),
        consumptionPriceIncreasePercentage = 4.percent
      )
    }

    fun demoPresentation(): PricesTrendScenario {
      return PricesTrendScenario(
        guaranteedFeedInPrice = PricePerKWh(8.4.cents100),
        consumptionPrice = PricePerKWh(40.cents100),
        consumptionPriceIncreasePercentage = 4.percent
      )
    }

    fun demoPresentationAdditional(): PricesTrendScenario {
      return PricesTrendScenario(
        guaranteedFeedInPrice = PricePerKWh(8.4.cents100),
        consumptionPrice = PricePerKWh(40.cents100),
        consumptionPriceIncreasePercentage = 0.04
      )
    }


    fun demo(): PricesTrendScenario {
      return PricesTrendScenario(
        guaranteedFeedInPrice = null,
        consumptionPrice = PricePerKWh(51.cents100),
        consumptionPriceIncreasePercentage = 4.percent
      )
    }

  }
}
